import axios from "axios";
//GET ALL CARCATAGORY BY COUNTRY
export const CANCEL_INVOICE_CASES = "CANCEL_INVOICE_CASES";
export const CANCEL_INVOICE_CASES_LOADING =
"CANCEL_INVOICE_CASES_LOADING";
export const CANCEL_INVOICE_CASES_LOADING_FAILED =
"CANCEL_INVOICE_CASES_LOADING_FAILED";

// HELPER ACTIONS CREATORS
//************************************** /

export const cancelInvoiceLoading = ms => ({
    type: CANCEL_INVOICE_CASES_LOADING,
    payload: ms
    });
    
    export const cancelInvoiceLoadingFailed = ms => ({
    type: CANCEL_INVOICE_CASES_LOADING_FAILED,
    payload: ms
    });

// RIDER PHINE NUBER
export function cancelInvoice(id,cancelInvoiceSuccess) {
  /* ${process.env.REACT_APP_FILE}/accountRoutes/api/v1/caseQuotations/getCountOfQuotation  */
    const request = axios.delete(
      `${process.env.REACT_APP_FILE}/accountRoutes/api/v1/caseInvoices/cancelInvoice/${id}`,
      {
        headers: { 'Authorization': 'bearer ' +localStorage.accountantToken}
      });

    return dispatch => {

    dispatch(cancelInvoiceLoading());
 
    request
    .then(response => {   
      console.log(response,"response, cancel invoice")   
    if (response.status == 200) {
    dispatch({
    type: CANCEL_INVOICE_CASES,
    payload: response.data
    });
  if(cancelInvoiceSuccess){
    cancelInvoiceSuccess()
  }
    } else {
      
    throw new Error(JSON.stringify(response.data.response.msg));
    }
    })
    .catch(error => {
        
    if (error.response) {
    if (error.response.status == "404") {
        console.log(error.response)
    dispatch(
        cancelInvoiceLoadingFailed(error.response.data.message)
    );
    } else {
    dispatch(cancelInvoiceLoadingFailed(error.response.data.message));
    }
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    } else if (error.request) {
    /*
    * The request was made but no response was received, `error.request`
    * is an instance of XMLHttpRequest in the browser and an instance
    * of http.ClientRequest in Node.js
    */
    dispatch(cancelInvoiceLoadingFailed(error.request));
    
    console.log(error.request);
    } else {
    // Something happened in setting up the request and triggered an Error
    console.log("Error", error.message);
    dispatch(cancelInvoiceLoadingFailed(error.message));
    }
    console.log(error);
    });
    };
    }


